import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { ConfirmationDialogComponent } from 'src/app/components/shared-components/confirmation-dialog/confirmation-dialog.component';
import { Router, ActivatedRoute } from '@angular/router';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { LocationsTurnsService } from 'src/app/services/turns-services/locations-turns-service/locations-turns.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-turns-location-resume-card',
  templateUrl: './turns-location-resume-card.component.html',
  styleUrls: ['./turns-location-resume-card.component.scss']
})
export class TurnsLocationResumeCardComponent implements OnInit, OnDestroy {

  @Input() location;
  @Input() viewDisposition;
  updateStatusLocationSubscription: Subscription;
  deleteLocationSubscription: Subscription;

  constructor(private snackbarService: SnackBarService,
              private router: Router,
              private translateService: TranslateService,
              private locationsTurnsService: LocationsTurnsService,
              private activatedRoute: ActivatedRoute,
              private dialog: MatDialog) { }

  ngOnInit() { }

  public toggleStatus() {
    this.updateStatusLocationSubscription = this.locationsTurnsService.updateStatusLocation(this.location.InternalId).subscribe(
      (res) => {
        this.location.Active = res['data']['status'];
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public gotoDetails(e) {
    if ((e.target.className !== 'mat-icon notranslate material-icons mat-icon-no-color') && (e.target.className !== 'mat-icon-button') && (e.target.tagName !== 'SPAN')) {
      this.router.navigate(['../location', this.location.InternalId], {relativeTo: this.activatedRoute.parent});
    }
  }

  public deleteLocation() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'important',
        messages: ['turns-page.delete location', 'delete anyway']
      }
    });

    dialogRef.afterClosed().subscribe(action => {
      if (action) {
        this.deleteLocationSubscription = this.locationsTurnsService.deleteLocation(this.location.InternalId).subscribe(
          (res) => {
            this.locationsTurnsService.refreshLocations();
          },
          (error) => {
            this.snackbarService.open(error['error']['message'], 'error');
          }
        );
      }
    });
  }

  public getLocationStatus() {
    if (this.location.Status) {
      return this.translateService.instant(this.location.Status);
    }
  }

  public getColor() {
    switch (this.location.Status) {
      case 'AVAIABLE':
        return 'success';
      case 'CLOSED':
        return 'error';
      case 'ATTENDING':
        return 'warning';
    }
  }

  ngOnDestroy() {
    if (this.updateStatusLocationSubscription) { this.updateStatusLocationSubscription.unsubscribe(); }
    if (this.deleteLocationSubscription) { this.deleteLocationSubscription.unsubscribe(); }
  }
}
